export const UNFOLLOW_CONFIRM_COPY = {
  cancel: 'No, Cancel',
  unfollow: 'Unfollow',
  button: 'Yes, Unfollow',
  desc: 'Are you sure you want to unfollow',
};
